import React from 'react';
import { Container } from '@fiverr-private/layout_components';
import { Text } from '@fiverr-private/typography';
import { Image } from '@fiverr-private/media';
import { useImageLoading, SkeletonLoading } from '@fiverr-private/identification_core';

interface ImageBlockProps extends Pick<React.ComponentProps<typeof Image>, 'display' | 'src' | 'onLoad' | 'alt'> {}

const ImageBlock: React.FC<ImageBlockProps> = ({ alt, display = 'block', src, onLoad }) => (
    <Image display={display} src={src} onLoad={onLoad} alt={alt} maxHeight="100%" width="100%" objectFit="cover" />
);

interface CreateBannerProps {
    imageSrcMd: string;
    imageSrcLg: string;
    title?: string;
    titleSize?: React.ComponentProps<typeof Text>['size'];
    titlePaddingY?: React.ComponentProps<typeof Container>['paddingY'];
    extraContent?: React.ReactNode;
}

export const CreateBanner: React.FC<CreateBannerProps> = ({
    imageSrcMd,
    imageSrcLg,
    title,
    titleSize = 'b_xl',
    titlePaddingY = '20',
    extraContent,
}) => {
    const { loading: loadingMd, onLoad: onLoadMd } = useImageLoading(imageSrcMd);
    const { loading: loadingLg, onLoad: onLoadLg } = useImageLoading(imageSrcLg);

    return (
        <SkeletonLoading loading={loadingMd || loadingLg}>
            <Container position="relative" height="100%" width="100%" maxHeight="100vh">
                <Container
                    width="100%"
                    paddingY={titlePaddingY}
                    paddingX="12"
                    position="absolute"
                    opacity="0.8"
                    display="flex"
                    alignItems="center"
                    textAlign="center"
                    direction="column"
                >
                    <Text color="white" size={titleSize}>
                        {title}
                    </Text>
                    {extraContent}
                </Container>
                <ImageBlock
                    alt={title}
                    display={{ md: 'block', lg: 'none' }}
                    src={imageSrcMd || imageSrcLg}
                    onLoad={onLoadMd}
                />
                <ImageBlock
                    alt={title}
                    display={{ md: 'none', lg: 'block' }}
                    src={imageSrcLg || imageSrcMd}
                    onLoad={onLoadLg}
                />
            </Container>
        </SkeletonLoading>
    );
};
